export default __webpack_public_path__ + "static/media/1163.159d2122.png";